import { Col, Container, Card, Table, Spinner, Button } from "react-bootstrap";
import Layout from "../../components/Layout";
import Paginator from "../../components/table/Paginator";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import RecordFilter from "../../components/RecordFilter";
import { getSalesforceMerchantList } from "../../redux/slices/account.service";
import { useNavigate } from "react-router-dom";

const Salesforces = () => {
  const dispatch = useDispatch()
  const isLoaded = useRef(false)
  const navigate = useNavigate();

  const [results, setResults] = useState([])
  const [paginationData, setpaginationData] = useState({next: '', prev: ''})
  const [payload, setPayload] = useState({
      page: 1,
      from_date: '',
      to_date: '',
      status: '',
      download: '',
      filter_by: '',
      sort_by: '',
      filter: ''
  })
  const [loading, setLoading] = useState(false)
    
  useEffect(() => {
      if(!isLoaded.current) {
          loadMerchants()
          isLoaded.current = true
      }
  }, [payload.page])

  const loadMerchants = (download = false) =>  {
      let requestPayload = payload
      if(download) {
          requestPayload.download = 'True'
      }
      setLoading(true)
      dispatch(getSalesforceMerchantList(requestPayload))
      .then((response) => {
          setPayload((prevState) => ({...prevState, download: ''}))
          if(response.payload.results) {
            setResults(response.payload.results)
          }

          if(response.payload?.next || response.payload?.previous) {
              const data = {
                  next: response.payload?.next,
                  prev: response.payload?.previous,
              }
              setpaginationData(data)
          }
      })
      .finally(() => setLoading(false))
  }

  const handlePagination = (data) => {
      setPayload({...payload, page: data})
      isLoaded.current = false
  }

  const handleInput = (event) => {
      const { name, value } = event.target
      setPayload((prevState)=> ({...prevState,[name]:value}))
  }

  const handleSearch = () => {
      loadMerchants()
  }

  return (
      <Layout>
          <Container className="mt-4 px-4 mb-4">
              <Col md={12} className="d-flex align-items-center justify-content-between no-print">
                <h5>Salesforce Merchants</h5>
                <Button type="button" size="sm" onClick={ () => navigate("/sales-force/transactions") }>Transactions</Button>
              </Col>
              {
                  loading ? (
                      <div className="page-loader">
                          <Spinner size="lg" variant="primary"/>
                      </div>
                  ) : null
              }
              <div className="mt-4 no-print">
                  {/* <RecordFilter
                      handleInput={handleInput}
                      handleSearchSubmit={handleSearch}
                      params={[
                        {label: 'Date', value: 'date'},
                      ]}
                  /> */}
                  <Card className="border-0 shadow-sm">
                      <Card.Header className="bg-primary text-white d-flex justify-content-between">
                        Merchants
                      </Card.Header>
                      <Card.Body className="table-responsive">
                          <Table size="sm" className="table-color table-stripedd w-100">
                              <thead>
                                  <tr>
                                      <th>Merchant ID</th>
                                      <th>Store Name</th>
                                      <th>First Name</th>
                                      <th>Last Name</th>
                                      <th>Email</th>
                                      <th>Phone Number</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  {
                                      results?.length ? (
                                          results?.map((item, index) => (
                                            <tr key={index}>
                                                <td className="m-0 text-primary">
                                                    <button type="button" className="btn-plain text-primary"
                                                        onClick={ () => navigate(`/businesses/${item.merchant_ID}`)}
                                                    >
                                                        <strong>{item.merchant_ID}</strong>
                                                    </button>
                                                </td>
                                                <td>{item.store_name}</td>
                                                <td> {item.first_name}</td>
                                                <td>{item.last_name}</td>
                                                <td>{item.email}</td>
                                                <td>{item.mobile}</td>
                                            </tr>
                                          ))
                                      )
                                      : 
                                      (
                                        <tr>
                                            <td colSpan={6} className="text-center text-muted">No data found</td>
                                        </tr>
                                      )
                                  }
                              </tbody>
                          </Table>
                      </Card.Body>
                  </Card>
                  {
                      results?.length ? (
                          <div className="table-responsive mt-2">
                              <Paginator
                                  next={paginationData.next} 
                                  prev={paginationData.prev}
                                  setCurrentPage={ handlePagination }
                              />
                          </div>
                      ) : null
                  }
              </div>
          </Container>
      </Layout>
  );
}

export default Salesforces;